export var AppUpdateInstallStatus;
(function (AppUpdateInstallStatus) {
    AppUpdateInstallStatus[AppUpdateInstallStatus["UNKNOWN"] = 0] = "UNKNOWN";
    AppUpdateInstallStatus[AppUpdateInstallStatus["PENDING"] = 1] = "PENDING";
    AppUpdateInstallStatus[AppUpdateInstallStatus["DOWNLOADING"] = 2] = "DOWNLOADING";
    AppUpdateInstallStatus[AppUpdateInstallStatus["INSTALLING"] = 3] = "INSTALLING";
    AppUpdateInstallStatus[AppUpdateInstallStatus["INSTALLED"] = 4] = "INSTALLED";
    AppUpdateInstallStatus[AppUpdateInstallStatus["FAILED"] = 5] = "FAILED";
    AppUpdateInstallStatus[AppUpdateInstallStatus["CANCELED"] = 6] = "CANCELED";
    AppUpdateInstallStatus[AppUpdateInstallStatus["DOWNLOADED"] = 11] = "DOWNLOADED";
})(AppUpdateInstallStatus || (AppUpdateInstallStatus = {}));
//# sourceMappingURL=types.js.map